export const ADD_MESSAGE = 'ADD_MESSAGE';
export const POP_MESSAGE = 'POP_MESSAGE';
export const RESTART = 'RESTART';
export const CLEAR_CHAT = 'CLEAR_CHAT';
